<template>
  <div :id="localId" class="svg_wrapper"></div>
</template>

<script>
import * as d3 from 'd3'
import mx_Core from './includes/mixins/zMixins'        

export default {
  name: "j-chart-area-summary",
  mixins: [mx_Core],
  props: {
    id: String,
    modeExport: Boolean,
    getSelectItems: String,  

    FilterValues: { type: Object, default: () => ({}) },
    ColumnProps: { type: Array, default: () => ([]) },
    Canvas: { type: Object, default: () => ({}) },
    Text: { type: Object, default: () => ({}) },
    DataItems: { type: Array, default: () => ([]) },
    Queries: { type: Object, default: () => ({}) },

    callback: { type: Object, default: () => ({}) },
  },

  created() {
    this.localId = `${this.id || 'j-chart-custom'}_${this.safeId('')}`
  },

  mounted() {
    this.register(this.draw)
  },

  methods: {
    draw() {
      if (!this.ready2draw) {
        return
      }

      this.clear()
      this.set_LocalValues()
      
      this.drawCanvas()
      this.drawing()
      this.drawNotes()
      this.drawTexts()
      this.complete()
    },

    drawing() {
      this.Area_Canvas = this.svg
      .append('g')
      .attr('id', 'Cansvas_Area')
      .attr('transform', `translate(0.5, 0.5)`)
      .attr('font-family', 'roboto')

      this.set_Defs()
      this.draw_Header()
    },
  }
}
</script>

<style lang="scss" scoped>
  // .svg_wrapper {
  //   width: 1600px;
  //   height: 1132px;

  //   overflow: hidden;
  // }
</style>